import { useSelector } from 'react-redux';
import { selectUserPermissions, selectIsReadOnly } from '@/entities/layout';

export const usePermissions = () => {
  const permissions = useSelector(selectUserPermissions);
  const isReadOnly = useSelector(selectIsReadOnly);

  const checkPermission = (permission: keyof typeof permissions): boolean => {
    if (!permissions) return false;
    return Boolean(permissions[permission]);
  };

  const checkRole = (role: string): boolean => {
    if (!permissions?.roles) return false;
    return permissions.roles.includes(role);
  };

  const canAccessMaintenance = permissions?.canAccessMaintenance || false;

  return {
    permissions,
    isReadOnly,
    isAdmin: permissions?.isAdmin || false,
    isProjectAdmin: permissions?.isProjectAdmin || false,
    canAccessMaintenance,
    roles: permissions?.roles || [],
    checkPermission,
    checkRole,

    canManageUsers: permissions?.isAdmin || permissions?.isProjectAdmin || false,
    canViewReports: !isReadOnly,
    canExportData: !isReadOnly,
    canEditData: !isReadOnly
  };
};
